"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeContent = exports.emptyValue = void 0;
const authz_1 = require("../codec/cosmos/authz/v1beta1/authz");
const feegrant_1 = require("../codec/cosmos/feegrant/v1beta1/feegrant");
const grant_1 = require("../provider/amino/types/grant");
exports.emptyValue = {
    typeUrl: "",
    value: {},
};
const decodeContent = (content) => {
    if (!content) {
        return exports.emptyValue;
    }
    switch (content.typeUrl) {
        case grant_1.GrantTypes.GenericAuthorization: {
            return Object.assign(Object.assign({}, content), { value: authz_1.GenericAuthorization.decode(content.value) });
        }
        case grant_1.GrantTypes.AllowedMsgAllowance: {
            const value = feegrant_1.AllowedMsgAllowance.decode(content.value);
            return Object.assign(Object.assign({}, content), { value: Object.assign(Object.assign({}, value), { allowance: Object.assign({}, (0, exports.decodeContent)(value.allowance)) }) });
        }
        case grant_1.GrantTypes.BasicAllowance: {
            return Object.assign(Object.assign({}, content), { value: feegrant_1.BasicAllowance.decode(content.value) });
        }
        default:
            return exports.emptyValue;
    }
};
exports.decodeContent = decodeContent;
